import { QrCode } from 'lucide-react';
import { useAuth } from '../../context/AuthContext.js';
import { canScanQrAttendance } from '../../utils/networkMode.js';
import { DashboardLayout, PageHeader } from '../common/page_component/index.js';
import ScanQrStatusButton from '../shipment-qr-status/ScanQrStatusButton.js';

const StaffDashboard = () => {
  const { user } = useAuth();
  const attendanceReady = canScanQrAttendance(user);

  return (
    <DashboardLayout hideSidebar>
      <PageHeader
        title="Scan QR"
        subtitle="Scan the branch QR to mark attendance. The first scan clocks in and the next scan clocks out."
      />
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-8 max-w-lg">
        <div className="flex items-start gap-3 mb-5">
          <div className="w-12 h-12 rounded-xl bg-orange-100 flex items-center justify-center shrink-0">
            <QrCode className="w-6 h-6 text-orange-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-800">Attendance</h2>
            <p className="text-sm text-gray-500 mt-1">
              Keep GPS on and stand at the location hub. This scan is for attendance only.
            </p>
          </div>
        </div>
        {attendanceReady ? (
          <ScanQrStatusButton fullWidth label="Scan QR" />
        ) : (
          <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
            QR attendance is not enabled for this company. Ask an admin to turn on Attendance and QR attendance.
          </p>
        )}
      </div>
    </DashboardLayout>
  );
};

export default StaffDashboard;
